// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"8452d307","147":"203ebbdf","171":"0a14e4f1","374":"b0562cab","507":"b87f2adf","528":"613554ae","679":"dbeca06f","780":"d532925c","903":"d91bc874"}[chunkId] + ".chunk.js";
};